export const UPLIFT_WIDGET_SCRIPT_ID = 'uplift-embed-widget';
export const UPLIFT_WIDGET_SCRIPT_SRC =
  'https://app.uplift.aero/assets/widget/widget.js';

export const UPLIFT_INSTANT_ESTIMATE_GUID =
  'z7d0b5bbd9bc6a6c5fbdc6ac02ce4b32a4a0596e';

export const UPLIFT_EMPTY_LEG_GUID = 'l601e99d5adb40f9fb8a4f58ac37b716eff39be3';

/**
 * Uplift ships its own Angular bundle that talks to this API directly from the
 * browser. We mirror the submissions it makes into Pipedrive, so the paths below
 * are matched against outgoing XHR requests. Keep them in sync with the widget.
 */
export const UPLIFT_API_BASE = 'https://app.uplift.aero/api/';

export const UPLIFT_ENDPOINTS = {
  /** POST — contact details, sent by both the lead gate and the inquire dialog */
  lead: 'widget/lead',
  /** POST — inquiry for one specific trip card */
  inquire: 'widget/inquire',
  /** GET/POST — route search, carries the origin/destination/date context */
  trips: 'widget/trips',
  /** GET — blurred placeholder cards shown behind the lead gate, never a real search */
  mockTrips: 'widget/trips/mock',
  /** GET — autocomplete, used to resolve airport ids to human readable names */
  locations: 'widget/locations',
  cities: 'widget/cities',
  airports: 'widget/airports',
} as const;

/** Our own endpoint that forwards a captured submission to Pipedrive */
export const UPLIFT_TRACKER_API = '/api/upliftLead';

/**
 * How long to wait after a captured lead for the route search that follows it.
 * The widget posts the lead first and only then runs the search request.
 */
export const UPLIFT_LEAD_FLUSH_DELAY_MS = 5000;
